<template>
    <div class="table__wrap">
        <div class="staff_nav">
            新增员工
        </div>
        <div class="staff_length"></div>
        <div class="formtable">
            <span style="font-size:12px;color:#999999;padding-bottom:20px;display:block">请输入员工信息，然后点击提交按钮。工号、邮箱、姓名、手机必填。</span>
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="工号：" prop="id">
                    <el-input v-model="form.id" style="width:340px" size="small" maxlength="6"></el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="form.name" style="width:340px" size="small" maxlength="6"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="email">
                    <el-input v-model="form.email" style="width:340px" size="small"></el-input>
                </el-form-item>
                <el-form-item label="手机：" prop="mobile">
                    <el-input v-model="form.mobile" style="width:340px" size="small" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="入职时间：" size="small">
                    <el-date-picker
                        v-model="form.indate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="部门：">
                    <DepartmentCascade  size="small" ref="cascadeOne" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne9" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo9" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree9" v-on:getDepartmentFour="showDepartmentFour9" v-bind:four="parentMsgFour"></DepartmentCascade>
                </el-form-item>
                <el-form-item label="地点：" size="small">
                    <el-select  placeholder="请选择" v-model="form.area">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职位：">
                    <el-input v-model="form.zhiwei" style="width:340px" size="small"></el-input>
                </el-form-item>
                <el-form-item label="级别：">
                    <el-input v-model="form.level" style="width:340px" size="small"></el-input>
                </el-form-item>
                <div class="staff_length1"></div>
                <el-form-item label="生日：" size="small">
                    <el-date-picker
                    v-model="form.birth"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <!-- <el-date-picker
                    v-else
                    v-model="form.birth"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd">
                    </el-date-picker> -->
                </el-form-item>
                <el-form-item label="性别：" prop="gender">
                  <el-radio-group v-model="form.gender">
                    <el-radio v-model="radio" label="男"></el-radio>
                    <el-radio v-model="radio" label="女"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="学历：">
                    <el-input v-model="form.xueli" style="width:340px" size="small"></el-input>
                </el-form-item>
                <el-form-item label="学位：">
                    <el-input v-model="form.xuewei" style="width:340px" size="small"></el-input>
                </el-form-item>
                <el-form-item label="学校：">
                    <el-input v-model="form.xuexiao" style="width:340px" size="small"></el-input>
                </el-form-item>
                <el-form-item label="专业：">
                    <el-input v-model="form.zhuanye" style="width:340px" size="small"></el-input>
                </el-form-item>
                <el-form-item label="请上传图片：">
                    <el-upload
                    class="avatar-uploader"
                    action=""
                    :limit="1"
                    :http-request="onSuccess"
                    :file-list="adImg"
                    accept="image/jpg,image/png,image/jpeg"
                    list-type="text"
                    :before-upload="beforeAvatarUpload"
                    :on-remove="imgBroadcastRemove">
                    <el-button size="small" type="primary">点击上传</el-button><span>&nbsp;&nbsp;&nbsp;</span>
                    <span slot="tip" class="el-upload__tip" style="color:#999999">只能上传一张jpg/png文件，且不超过2M</span>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                  <template>
                    <img v-if="form.photo" :src="form.photo" alt="" style="width: 200px;height: 200px">
                  </template>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" size="small">提交</el-button>
                    <el-button size="small" @click="houtui">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import DepartmentCascade from '../components/DepartmentCascade.vue'
export default {
  data () {
    return {
      adImg: [],
      radio: '1',
      form: {
        id: '',
        name: '',
        email: '',
        mobile: '',
        indate: '',
        area: '',
        zhiwei: '',
        level: '',
        birth: '',
        xuewei: '',
        xueli: '',
        xuexiao: '',
        zhuanye: '',
        isnew: 'true',
        gender: '',
        photo: ''
      },
      rules: {
        id: [{ required: true, message: '请正确输入工号', trigger: 'blur' }],
        name: [{ required: true, message: '请正确输入姓名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        mobile: [
          { required: true, message: '请正确输入手机号', trigger: 'blur' }
        ]
      },
      options: [
        {
          value: '广州',
          label: '广州'
        },
        {
          value: '上海',
          label: '上海'
        },
        {
          value: '北京',
          label: '北京'
        }
      ],
      value: '',
      parentMsgOne: '',
      parentMsgTwo: '',
      parentMsgThree: '',
      parentMsgFour: '',
      secondApart: '',
      firstApart: '',
      thirdApart: '',
      fourthApart: ''
    }
  },
  components: {
    DepartmentCascade
  },
  created () {
    if (this.$route.query.id) {
      this.getXiuGaiData()
    }
  },
  watch: {
    $route: 'getPath'
  },
  methods: {
    showDepartmentOne9: function (one) {
      this.firstApart = one
    },
    showDepartmentTwo9: function (two) {
      this.secondApart = two
    },
    showDepartmentThree9: function (three) {
      this.thirdApart = three
    },
    showDepartmentFour9 (four) {
      this.fourthApart = four
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      // const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    onSuccess (res) {
      this.adImg.push(res.file)
    },
    imgBroadcastRemove (file, fileList) {
      this.adImg = fileList
    },
    onSubmit () {
      let self = this
      let formData = new FormData()
      formData.append('id', this.form.id)
      formData.append('name', this.form.name)
      formData.append('email', this.form.email)
      if (this.adImg[0]) {
        formData.append('photo', this.adImg[0])
      }
      formData.append('first', this.firstApart)
      formData.append('second', this.secondApart)
      formData.append('third', this.thirdApart)
      formData.append('fourth', this.fourthApart)
      formData.append('area', this.form.area)
      formData.append('mobile', this.form.mobile)
      formData.append('birth', this.form.birth)
      formData.append('gender', this.form.gender)
      formData.append('xuewei', this.form.xuewei)
      formData.append('xueli', this.form.xueli)
      formData.append('xuexiao', this.form.xuexiao)
      formData.append('zhuanye', this.form.zhuanye)
      formData.append('indate', this.form.indate)
      formData.append('zhiwei', this.form.zhiwei)
      formData.append('level', this.form.level)
      if (this.$route.query.id) {
        formData.append('isnew', false)
      }
      this.$axios.post('/api/yuangong/add2', formData).then(function (res) {
        if (res.data.status === 'success') {
          self.$router.push('/staff')
          sessionStorage.setItem('page', 'second')
        }
      })
    },
    houtui () {
      this.$router.push('/staff')
    },
    getXiuGaiData () {
      let self = this
      this.getPath()
      this.$axios
        .post('/api/yuangong/list2', {
          gong_id: this.routerId
        })
        .then(function (res) {
          self.form = res.data.yuangong_data[0]
          self.parentMsgOne = res.data.yuangong_data[0].jiagou_first
          self.parentMsgTwo = res.data.yuangong_data[0].jiagou_second
          self.parentMsgThree = res.data.yuangong_data[0].jiagou_third
          self.parentMsgFour = res.data.yuangong_data[0].jiagou_forth
          if ((self.parentMsgOne !== '') & (self.parentMsgOne !== '-1')) {
            self.$refs.cascadeOne.parentHandleclick(
              self.parentMsgOne,
              self.parentMsgTwo,
              self.parentMsgThree,
              self.parentMsgFour
            )
          }
          if (
            (self.parentMsgOne !== '') &
            (self.parentMsgOne !== '-1') &
            (self.parentMsgTwo === '-1') &
            (self.parentMsgThree === '-1') &
            (self.parentMsgFour === '-1')
          ) {
            self.$refs.cascadeOne.parentHandleclick(self.parentMsgOne)
          }
          if (
            (self.parentMsgOne !== '') &
            (self.parentMsgOne !== '-1') &
            (self.parentMsgTwo !== '') &
            (self.parentMsgTwo !== '-1') &
            (self.parentMsgThree === '-1') &
            (self.parentMsgFour === '-1')
          ) {
            self.$refs.cascadeOne.parentHandleclick(
              self.parentMsgOne,
              self.parentMsgTwo
            )
          }
          if (
            (self.parentMsgOne !== '') &
            (self.parentMsgOne !== '-1') &
            (self.parentMsgTwo !== '') &
            (self.parentMsgTwo !== '-1') &
            (self.parentMsgThree !== '') &
            (self.parentMsgThree !== '-1') &
            (self.parentMsgFour === '-1')
          ) {
            self.$refs.cascadeOne.parentHandleclick(
              self.parentMsgOne,
              self.parentMsgTwo,
              self.parentMsgThree
            )
          }
        })
    },
    getPath () {
      this.routerId = this.$route.query.id
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  &__wrap {
    margin-top: 20px;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 1);
  }
}
.staff_nav {
  padding: 20px;
}
.staff_length {
  border: 1px solid #e9e9e9;
}
.formtable {
  padding: 20px;
}
.staff_length1 {
  border: 1px solid #e9e9e9;
  margin-bottom: 20px;
}
</style>
